import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConnectionService } from '../../../services/connection-service';

@Component({
  selector: 'instant-checkup-image-only',
  templateUrl: './image-only.html',
  styleUrls: ['./image-only.scss'],
  standalone: false,
})
export class InstantCheckupImageOnlyComponent implements OnInit {
  loading: boolean = true;
  imagePath: string;
  type: string;

  constructor(private conn: ConnectionService, private route: ActivatedRoute) {
  }

  async ngOnInit(): Promise<void> {
    const id: string = this.route.snapshot.params.id;
    try {
      const username: string = this.route.snapshot.queryParams.username || await this.findUsername(id);
      if (username) {
        const [checkup]: Array<any> = await this.conn.fetchUserInstantCheckup({
          userId: username,
          id: [id],
          project: ['type', 'imagePath'],
        });
        this.imagePath = checkup?.imagePath;
        this.type = checkup?.type;
      }
    } finally {
      this.loading = false;
    }
  }

  private async findUsername(id: string): Promise<string> {
    const checkup: any = await this.conn.getInstantCheckupById(id);
    const userId: string = checkup?.get('user')?.id;
    if (!userId) return undefined;
    const user: any = await this.conn.findOneUser({ where: { objectId: userId }, project: ['username'] });
    return user?.get('username');
  }
}
